export default __webpack_public_path__ + "static/media/plus-circle.9436662b.svg";